import { call, put } from 'redux-saga/effects';
import { types as noteTypes, MAX_NOTES } from '../reducers/notes';
import * as Api from '../utils/Api';

export function* fetchNotes(action) {
  const { repoUUID, state = 'active' } = action;
  if (!repoUUID) {
    throw new Error('Missing required parameters for fetching notes.');
  }
  let notes = [];
  let url = `projects/${repoUUID}/code-notes?state=${state}&page=1`;
  let page = 1;
  while (true) {
    const response = yield call(Api.get, url);
    if (!response.success) {
      yield put({
        type: noteTypes.NOTES_FAILURE,
        error: response.data ? response.data.error_message : 'Unknown error',
        errorCode: response.status,
      });
      return;
    }
    const newNotes = response.data.data;
    notes = [...notes, ...newNotes];
    if (notes.length > MAX_NOTES) {
      notes = notes.slice(0, MAX_NOTES);
      break;
    }

    if (!response.data.next_page_url) {
      // reached the end of pages of notes
      break;
    }
    page += 1;
    url = `projects/${repoUUID}/code-notes?state=${state}&page=${page}`;
  }

  yield put({
    type: noteTypes.NOTES_SUCCESS,
    isActive: state === 'active',
    notes,
    repoUUID,
  });
}
